const resource = 'login';

export default ($axios, isAdmin = false) => ({
    // GET
    loginWithToken(token) {
        return $axios.post(`/${resource}/${token}`);
    },
    login(payload) {
        return $axios.post(`/${resource}`, payload);
    },
    passwordReset(payload) {
        return $axios.post('/password/reset', payload);
    },
    getIntendedRedirect() {
        return $axios.get('/intended-redirect');
    }
});
